import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  LoggingService,
  NotificationCenterMessageType,
  NotificationCenterMessageView,
  NotificationCenterService,
  NotificationLoyaltyType,
} from '@fgb/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationCenterToastComponent } from '../toast/notification-center-toast';
import { AlertNotification } from '../alert/alert-notification.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_NOTIFICATION_COMPONENTS, AlertNotificationComponentMap } from '../alert/alert-notification.config';

/**
 * Handles notification toast messages using the notificationReceived observable
 * Should only be implemented once otherwise it'll duplicate toasts
 */
@Component({
  selector: 'fgbcl-notification-toast',
  templateUrl: './notification-toast.component.html',
})
export class NotificationToastComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  constructor(
    private toastrService: ToastrService,
    private notificationService: NotificationCenterService,
    private logService: LoggingService,
    private modalService: NgbModal,
    @Inject(ALERT_NOTIFICATION_COMPONENTS) private notificationComponents: AlertNotificationComponentMap
  ) {}

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnInit(): void {
    this.notificationService.notificationReceived$.pipe(takeUntil(this._destroyed$)).subscribe((notification) => {
      switch (notification.messageType) {
        case NotificationCenterMessageType.Toast:
        case NotificationCenterMessageType.PersistentToast:
          this.createToastNotification(notification);
          break;
        case NotificationCenterMessageType.Alert:
          this.createAlertNotification(notification);
      }
    });
  }

  createToastNotification(notification: NotificationCenterMessageView) {
    const toast = this.toastrService.show('', '', {
      toastComponent: NotificationCenterToastComponent,
      disableTimeOut: notification.messageType === NotificationCenterMessageType.PersistentToast,
      closeButton: true,
      tapToDismiss: false,
    });

    if (toast.toastRef && toast.toastRef.componentInstance) {
      toast.toastRef.componentInstance.notification = notification;
    }
  }

  createAlertNotification(notificaiton: NotificationCenterMessageView) {
    let alertComponent = this.notificationComponents[notificaiton.loyaltyActionId];
    if (alertComponent == undefined) {
      this.logService.debug('unable to find component for actionid ' + notificaiton.loyaltyActionId);
      return;
    }
    if (notificaiton.loyaltyActionId == NotificationLoyaltyType['ScorecardComplete']) {
      let modalRef = this.modalService.open(alertComponent, {
        centered: true,
        windowClass: 'scorecard-modal-content',
        backdropClass: 'scorecard-modal-backdrop',
      });
      let alertComponentRef = modalRef.componentInstance;
      alertComponentRef.scorecardId = notificaiton.parameters.notificationReference;
    } else {
      let modalRef = this.modalService.open(alertComponent);
      let alertComponentRef = modalRef.componentInstance as AlertNotification;
      alertComponentRef.notification = notificaiton;
    }
  }
}
